export const getPrepareHeaders = (headers: Headers) => {
  const token = localStorage.getItem('magjistraturaAppToken');
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return headers;
};
